/* eslint-disable react/prop-types */
import { Grid } from '@mui/material';

import React, { useState } from 'react';

import ViewStaff from './ViewStaff';

function Staff() {
	return (
		<Grid container>
			<Grid item xs={12} lg={12} xl={12}>
				<ViewStaff />
			</Grid>
		</Grid>
	);
}

export default Staff;
